class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    // Grab form elements
    this.el = {
      form: this.querySelector('form'),
      submit: this.querySelector('input[data-submit]'),
      languages: this.querySelectorAll('input[data-language]'),
    };
    // Grab trigger and target elements
    this.trigger = this.querySelector('button[data-trigger]');
    this.target = this.querySelector('div[data-target]');

    // Add event listener to trigger
    this.trigger.addEventListener('click', () => {
      this.target.classList.toggle('hidden');
    });

    // Loop over languages and add event listener
    this.el.languages.forEach((language) => {
      language.addEventListener('change', (event) => {
        // set language value of submit button
        this.el.submit.value = event.target.value;
        // check if form exists and submit
        this.el.form && this.el.form.submit();
      });
    });
  }
}

customElements.define('localization-form', LocalizationForm);
